<template>
  <div class="loading-screen">
    <img :src="splashImage" alt="Splash" class="full-screen-splash" />
    <div class="loading-bar-container">
      <div class="loading-bar">
        <div class="loading-fill"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingScreen',
  setup() {
    // Import splash image
    const splashImage = new URL('../assets/splash.png', import.meta.url).href;
    
    return {
      splashImage
    };
  }
};
</script>

<style scoped>
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.full-screen-splash {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.loading-bar-container {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px; /* Тонкая шкала */
  background: rgba(255, 255, 255, 0.1); /* Очень темный фон */
  z-index: 2;
}

.loading-bar {
  width: 100%;
  height: 100%;
}

.loading-fill {
  width: 100%; /* Полностью заполненная шкала */
  height: 100%;
  background: linear-gradient(to right, #2c3e50, #34495e, #3498db); /* Темно-серо-синий цвет */
  /* Убрана анимация для мгновенного отображения */
}
</style>